// Local-only overlays that don't need a redeploy:
//  - video approvals: Xavier marks a drill's candidate clip as vetted
//  - last active profile
const K_APPROVED = "training.videoApproved";
const K_LAST = "training.lastProfile";

function read<T>(k: string, f: T): T {
  try {
    const v = localStorage.getItem(k);
    return v ? (JSON.parse(v) as T) : f;
  } catch {
    return f;
  }
}
function write(k: string, v: unknown): void {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch {
    /* ignore */
  }
}

export function approvedMap(): Record<string, boolean> {
  return read<Record<string, boolean>>(K_APPROVED, {});
}
export function isVideoApproved(drillId: string, verified: boolean): boolean {
  return verified || approvedMap()[drillId] === true;
}
export function setVideoApproved(drillId: string, approved: boolean): void {
  const m = approvedMap();
  m[drillId] = approved;
  write(K_APPROVED, m);
}

export function getLastProfile(): string | null {
  return read<string | null>(K_LAST, null);
}
export function setLastProfile(id: string): void {
  write(K_LAST, id);
}
